export enum AuthContextAction {
    LOGIN_SUCCESS,
    RELOAD_USER,
    LOGOUT,
}
